var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { zoomIdentity, ZoomTransform } from 'd3-zoom';
export var initializeDiagramState = function (config) {
    var _a, _b, _c, _d;
    return {
        nodes: (_a = config === null || config === void 0 ? void 0 : config.nodes) !== null && _a !== void 0 ? _a : {},
        hiddenNodes: (_b = config === null || config === void 0 ? void 0 : config.hiddenNodes) !== null && _b !== void 0 ? _b : {},
        links: (_c = config === null || config === void 0 ? void 0 : config.links) !== null && _c !== void 0 ? _c : {},
        secondaryLinks: (_d = config === null || config === void 0 ? void 0 : config.secondaryLinks) !== null && _d !== void 0 ? _d : {},
        transform: (config === null || config === void 0 ? void 0 : config.transform)
            ? new ZoomTransform(config.transform.k, config.transform.x, config.transform.y)
            : zoomIdentity,
    };
};
export var interactiveDiagramReducer = function () {
    return function (state, action) {
        var _a;
        var _b, _c;
        switch (action.type) {
            case 'SET_VALUES':
                return __assign({}, action.payload);
            case 'SET_TRANSFORM':
                return __assign(__assign({}, state), { transform: action.payload });
            case 'MOVE_NODE':
                var prevNodePosition = (_c = (_b = state.nodes[action.payload.nodeId]) === null || _b === void 0 ? void 0 : _b.position) !== null && _c !== void 0 ? _c : { x: 0, y: 0 };
                var newNodePosition = {
                    x: prevNodePosition.x + action.payload.dx,
                    y: prevNodePosition.y + action.payload.dy,
                };
                return __assign(__assign({}, state), { nodes: __assign(__assign({}, state.nodes), (_a = {}, _a[action.payload.nodeId] = __assign(__assign({}, state.nodes[action.payload.nodeId]), { position: newNodePosition }), _a)) });
            default:
                throw new Error('Not an Interactive Diagram Action Type: ' + action.type);
        }
    };
};
//# sourceMappingURL=interactiveDiagramReducer.js.map